<script>
import api from "@/axios"
import Loader from "../components/loader"
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import TabPrecosTable from './tabprecos-table.vue'
import appConfig from "@/app.config"
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/produtos_anim.json'
import { produtosChart1, produtosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Tabelas de Preços",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, TabPrecosTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted tabprecos-list_0')

    console.log(getBaseUrl() + '_IMG')

    this.atualizaDataList()
  },
  data() {
    return {
      animationJson,
      title: 'Tabelas de Preços',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Tabelas de Preços',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      tabPrecosList: [],
      prodsChart1: produtosChart1,
      prodsChart2: produtosChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
    }
  },

  methods: {
    exportExcel(){
      console.log('exportExcel')
      const data = this.tabPrecosList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/tabprecos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])

        if (res.data[0]) {
          this.tabPrecosList = res.data[0]
          this.tabPrecosList.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }
          })
        }


        this.title = `(${this.tabPrecosList.length}) Tabelas de Preços`
        this.loadingList = false
        this.loadingGraph = false
      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/tabpreco`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


  },
}
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1000; position: absolute; top: 70px; right: 200px;">
      <Vue3Lottie :animationData="animationJson" :height="150" :width="250" />
    </span>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>

                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">

                  <router-link :to="`/tabpreco/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Nova Tabela de Preço
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <TabPrecosTable v-if="!loadingList"
                           :tabPrecosList="tabPrecosList"
                           @deletareg="deletaReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Grupos Destaque Ano</h4>
            <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="prodsChart1.series"
                :options="prodsChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Tabelas Destaque Semana</h4>
            <apexchart
                class="apex-charts"
                height="320"
                type="scatter"
                dir="ltr"
                :series="prodsChart2.series"
                :options="prodsChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>
